import _, { cloneDeep, get, merge, set } from 'lodash';
import Schema from 'validate';
import { ErrorValidation, Field, Validation } from '../types/types';
import { Required } from './ValidationTypes';
// import { isTrue } from '../../utils/helper';

export function GetFieldErrors(structure: any, application: any, readOnly?: boolean): ErrorValidation[] {
	const appCopy = _.cloneDeep(application);
	let applicationErrors = GetApplicationValidator(structure, appCopy, readOnly).validate(appCopy) as ErrorValidation[];
	console.log('APPLICATIOPNVALIDATOR errors', [...applicationErrors]);
	return applicationErrors;
}

function GetApplicationValidator(structure: any, application: any, readOnly?: boolean) {
	let object = {};
	let enableValidation = readOnly ? false : true;
	if (enableValidation) createSchema(structure, object, application);
	return new Schema(object, { strip: false });
}

function createSchema(structure: any, object: any, application: any) {
	structure?.forEach((structItem: any) => {
		if (structItem?.formStruc) {
			structItem?.formStruc?.forEach((item: any) => {
				item?.fields?.forEach((field: Field) => {
					if (field.path) {
						setValidationSchema(application, field, object);
					}
				});
			});
		}
		if (structItem?.children) {
			createSchema(structItem.children, object, application);
		}
	});
}

function setValidationSchema(application: any, field: Field, object: any) {
	const { validation, path } = field;
	const isFieldDisabled = field.disabled === true;
	if (validation) {
		validation.forEach((validate: Validation) => {
			let validationNotDisabled = !isFieldDisabled || validate.disabledValidation === false;
			if (validationNotDisabled) setValidateFunction(validate, application, path, object);
		});
	} else if (!isFieldDisabled) {
		setDefaultSchema(field, object);
	}
}

function setDefaultSchema(field: Field, object: any) {
	const { path } = field;
	// set Required as default, set NonRequired in formStruc if not needed
	if (field?.type === 'checkbox') return;
	if (field?.type === 'boolean') return;
	else set(object, path, { ...Required });
}

/**
 *
 * @param validate object of type Validation to set function (and parameters) to @param object, and translate path in params to value in @param application
 * @param application key value object containing data for forms
 * @param fieldPath path to value in @param application
 * @param object schema for validation library
 */
function setValidateFunction(validate: Validation, application: any, fieldPath: string, object: any) {
	const { params } = validate;
	let objectCopy = cloneDeep(object);

	if (params && params.length > 0) {
		const currentValidateFunction = get(objectCopy, fieldPath);

		const input = params.map((param) => {
			//get value from Application if param is path
			if (isAttributesPath(param)) {
				return get(application, param);
			}
			return param;
		});
		if (input.length > 0) {
			const validateFunction = validate.validateFunction as Function;
			if (currentValidateFunction) {
				set(object, fieldPath, merge(currentValidateFunction, validateFunction(...input)));
			} else {
				set(object, fieldPath, validateFunction(...input));
			}
		}
	} else {
		const currentValidateFunction = get(objectCopy, fieldPath);

		const { validateFunction } = validate;
		if (typeof validateFunction === 'function') {
			if (currentValidateFunction) {
				set(object, fieldPath, merge(currentValidateFunction, validateFunction()));
			} else {
				set(object, fieldPath, validateFunction());
			}
		} else {
			if (currentValidateFunction) {
				set(object, fieldPath, merge(currentValidateFunction, validateFunction));
			} else {
				set(object, fieldPath, validateFunction);
			}
		}
	}
}

function isAttributesPath(str: any): boolean {
	if (typeof str === 'string') {
		const regex = /^attributes(\.[a-zA-Z0-9_]+)+$/;
		return regex.test(str);
	}
	return false;
}
